export default __webpack_public_path__ + "static/media/card-parameter.cb8af138.svg";